import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

/**
 * @file Created on Thu Aug 09 2018
 * @author VBr
 */
import * as React from 'react';
import Input from '../../../../inputs/Input';
import FormGroupInline from '../../../../forms/FormGroupInline';
import Label from '../../../../typography/Label';

var RangeFloatingFilter =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RangeFloatingFilter, _React$Component);

  function RangeFloatingFilter(props) {
    var _this;

    _classCallCheck(this, RangeFloatingFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeFloatingFilter).call(this, props));
    _this.state = {
      from: '',
      to: ''
    };
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }
  /**
   * Gets called if parent filter's value changes and updates state accordingly
   * @param parentModel object with filter state
   */


  _createClass(RangeFloatingFilter, [{
    key: "onParentModelChanged",
    value: function onParentModelChanged(parentModel) {
      if (!parentModel) {
        this.setState({
          from: '',
          to: ''
        });
      } else {
        this.setState({
          from: parentModel.from,
          to: parentModel.to
        });
      }
    }
    /**
     * Sets input values
     * Calls parent filter's update hook
     * @param event Input's event object
     * @param results Validation results
     */

  }, {
    key: "onChange",
    value: function onChange(event) {
      var _this2 = this;

      if (this.state[event.target.name] !== event.target.value) {
        var state = this.state;
        state[event.target.name] = event.target.value;
        this.setState(state, function () {
          _this2.props.onFloatingFilterChanged(state);
        });
      }
    }
    /**
     * Renders range floating filter component
     */

  }, {
    key: "render",
    value: function render() {
      return React.createElement(FormGroupInline, {
        right: false
      }, React.createElement(Input, {
        type: "number",
        tiny: true,
        name: "from",
        placeholder: "From",
        value: this.state.from,
        onChange: this.onChange
      }), React.createElement(Label, null, "-"), React.createElement(Input, {
        type: "number",
        tiny: true,
        name: "to",
        placeholder: "To",
        value: this.state.to,
        onChange: this.onChange
      }));
    }
  }]);

  return RangeFloatingFilter;
}(React.Component);

export { RangeFloatingFilter as default };